// @flow

import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  size: string,
  className?: string,
};

function SearchIcon({ size = '20', className }: Props) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.653 13.3a5.686 5.686 0 01-3.437 1.15A5.72 5.72 0 013.5 8.725 5.72 5.72 0 019.216 3a5.72 5.72 0 015.716 5.726c0 1.29-.427 2.482-1.147 3.44l3.48 3.469a.798.798 0 010 1.13.804.804 0 01-1.135 0L12.653 13.3zm.675-4.574A4.118 4.118 0 009.216 4.6a4.118 4.118 0 00-4.111 4.126 4.117 4.117 0 004.111 4.123 4.118 4.118 0 004.112-4.123z"
        fill={colors.mediumGrey}
      />
    </svg>
  );
}

export default SearchIcon;
